import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { IoMenuOutline } from "react-icons/io5";
import { CategoryTree } from "../styled/header";
import useOutsideClick from "../../../../../hooks/useOutsideClick";

const Category = ({ isFixed = false }) => {
  const [openTree, setOpenTree] = useState(false);
  const [categories, setCategories] = useState([]);
  const [hoverPath, setHoverPath] = useState([]);

  const treeRef = useRef();

  useOutsideClick(treeRef, () => {
    setOpenTree(false);
  });

  useEffect(() => {
    getCategory();
  }, []);

  const buildCategoryTree = (flatList) => {
    const map = {};
    const tree = [];

    flatList.forEach((item) => {
      map[item.categoryId] = { ...item, children: [] };
    });

    flatList.forEach((item) => {
      const ids = item.path?.split("/").map(Number) || [];
      const parentId = ids[ids.length - 2];

      if (parentId && map[parentId]) {
        map[parentId].children.push(map[item.categoryId]);
      } else {
        tree.push(map[item.categoryId]);
      }
    });

    return tree;
  };

  const getCategory = async () => {
    try {
      const res = await axios.post("/api/categories");
      if (res.status === 200) {
        const data = sortCategories(res.data || []);
        setCategories(data);
      }
    } catch {
      console.error("카테고리 조회 실패");
    }
  };

  const treeData = buildCategoryTree(categories);

  const getLevelNodes = (tree, path = []) => {
    const levels = [];
    let current = tree;

    for (let i = 0; i <= path.length; i++) {
      levels.push(current);
      const nextId = path[i];
      const found = current.find((item) => item.categoryId === nextId);
      current = found?.children || [];
    }

    return levels;
  };

  const handleHover = (depth, categoryId) => {
    setHoverPath((prev) => [...prev.slice(0, depth), categoryId]);
  };

  const columns = getLevelNodes(treeData, hoverPath);

  const getCumulativeTop = (depth) => {
    let top = 0;

    for (let d = 0; d < depth; d++) {
      const parentId = hoverPath[d];
      const parentColumn = columns[d] || [];
      const parentIndex = parentColumn.findIndex((item) => item.categoryId === parentId);
      top += parentIndex >= 0 ? parentIndex * 30 : 0;
    }

    return top;
  };

  return (
    <div className="category">
      <button onClick={() => setOpenTree(!openTree)}>
        <IoMenuOutline />
        {!isFixed && "카테고리"}
      </button>
      {openTree && (
        <CategoryTree ref={treeRef}>
          <div className="tree">
            <div>
              {columns.map((columnData, depth) => {
                if (!columnData || columnData.length === 0) return null;

                const topOffset = getCumulativeTop(depth);

                return (
                  <div
                    className="column"
                    key={depth}
                    style={{ left: `${depth * 120}px`, top: `${topOffset}px` }}>
                    {columnData.map((item) => {
                      const isActive = hoverPath[depth] === item.categoryId;

                      return (
                        <button
                          key={item.categoryId}
                          onMouseEnter={() => handleHover(depth, item.categoryId)}
                          style={{
                            fontWeight: isActive ? 700 : 300,
                          }}>
                          {item.categoryName}
                        </button>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </CategoryTree>
      )}
    </div>
  );
};

export default Category;
